import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const SettingsPage = lazy(() => import('./SettingsPage'));

export const settingsRoutes: RouteObject[] = [
  {
    path: 'settings',
    element: (
      <ProtectedRoute action="settings:view">
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
];
